import { cosmeticColorStyle, cosmeticTitle } from "@/lib/cosmetics";

interface PlayerNameProps {
  name: string;
  // Equipped cosmetic ids (from the player's profile). Unknown/absent ids fall
  // back to a plain white name with no title chip, so this is safe to use even
  // before the cosmetics migration has run.
  title?: string | null;
  color?: string | null;
  // Extra classes for the name text (e.g. sizing). Color is applied via inline
  // style and overrides any text color here when a color cosmetic is equipped.
  nameClassName?: string;
}

// Renders a player's name with their equipped flair: an optional color/gradient
// on the name itself plus an optional title chip beside it. Shared by every
// surface that shows a name (leaderboard, profile, results) so flair looks
// identical everywhere.
export default function PlayerName({
  name,
  title,
  color,
  nameClassName = "",
}: PlayerNameProps) {
  const titleText = cosmeticTitle(title);
  const colorStyle = cosmeticColorStyle(color);
  return (
    <span className="inline-flex min-w-0 items-center gap-1.5">
      <span
        className={`truncate font-semibold ${nameClassName}`}
        style={colorStyle}
      >
        {name}
      </span>
      {titleText && (
        <span className="shrink-0 rounded-full border border-accent/50 bg-accent/10 px-2 py-0.5 text-[0.55rem] font-bold uppercase tracking-widest text-accent">
          {titleText}
        </span>
      )}
    </span>
  );
}
